// extracted by mini-css-extract-plugin
export default {"form__modal":"GLDSFormModal_form__modal__yopg8","modal__container":"GLDSFormModal_modal__container__Q0Qqd","title":"GLDSFormModal_title__XbXUH","form":"GLDSFormModal_form__Bva6M"};